import { render, staticRenderFns } from "./sidebarItem.vue?vue&type=template&id=5c055750&scoped=true&"
import script from "./sidebarItem.vue?vue&type=script&lang=js&"
export * from "./sidebarItem.vue?vue&type=script&lang=js&"
import style0 from "./sidebarItem.vue?vue&type=style&index=0&id=5c055750&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c055750",
  null
  
)

export default component.exports